import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { Alert } from "@mui/lab";
import {
	Button,
	IconButton,
	InputAdornment,
	Snackbar,
	TextField,
	Typography,
} from "@mui/material";
import React, { useState } from "react";
import { MESApiService } from "../../services";
import { AuthContext } from "../AuthContext";

export const LoginWithEmailAndPassword = () => {
	const [username, setUserName] = useState("");
	const [password, setPassword] = useState("");
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);

	const { saveUserData } = React.useContext(AuthContext);

	const login = async (e: any) => {
		e.preventDefault();
		const apiService = new MESApiService();
		const response = await apiService.authenticate(username, password);
		if (apiService.hasErrors) {
			setShowError(true);
			setError(apiService.error);
		} else {
			saveUserData(response);
		}
	};

	const handleCloseError = () => {
		setShowError(false);
		setError(undefined);
	};

	return (
		<>
			<form
				onSubmit={login}
				style={{
					width: "100%",
					marginTop: 1,
				}}
			>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					id="txtUserName"
					label="Username"
					name="userName"
					autoComplete="username"
					autoFocus
					sx={{
						marginBottom: (theme) => theme.spacing(2),
					}}
					value={username}
					onChange={(e) => setUserName(e.target.value)}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<PersonIcon
									sx={{
										color: (theme) => theme.palette.text.secondary,
									}}
								/>
							</InputAdornment>
						),
					}}
				/>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					name="password"
					label="Password"
					type="password"
					id="txtPassword"
					autoComplete="current-password"
					sx={{
						marginBottom: (theme) => theme.spacing(2),
					}}
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<LockIcon
									sx={{
										color: (theme) => theme.palette.text.secondary,
									}}
								/>
							</InputAdornment>
						),
					}}
				/>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					sx={{
						margin: (theme) => theme.spacing(2, 0),
						padding: (theme) => theme.spacing(1.2),
						fontWeight: 600,
						transition: "all 0.3s ease",
						"&:hover": {
							transform: "translateY(-2px)",
							boxShadow: (theme) => theme.shadows[4],
						},
					}}
					disabled={password.length === 0 || username.length === 0}
				>
					Login
				</Button>
				<Snackbar
					open={showError}
					autoHideDuration={6000}
					onClose={handleCloseError}
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				>
					<Alert
						severity="error"
						variant="filled"
						onClose={handleCloseError}
						action={
							<IconButton
								size="small"
								aria-label="close"
								color="inherit"
								onClick={handleCloseError}
							>
								<CloseIcon fontSize="small" />
							</IconButton>
						}
					>
						<Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
							Bad credentials
						</Typography>
						<Typography variant="body2">
							{error === undefined
								? "There was an error"
								: error.internalError.message === undefined
									? error.internalError
									: error.internalError.message}
						</Typography>
					</Alert>
				</Snackbar>
			</form>
		</>
	);
};
